<ng-container *ngIf="imageLoaded">
  <div class="flex justify-center m-10">
    <img alt="nick" *ngIf="handsetService.isMobile" height="250px" [src]="URL">
    <img alt="nick" *ngIf="!handsetService.isMobile" height="180px" [src]="URL" />
  </div>

  <form [formGroup]="form">
    <div fxLayout="column" fxLayoutAlign="center center">
      <h1>
        Witaj w Panelu Payka!
      </h1>
      <p>
        Powiedz nam jak mamy się do Ciebie zwracać?
      </p>
    </div>

    <div fxLayout="column"
         style=" margin-top: 3rem"

    fxLayoutGap="24px" fxLayoutAlign="center center">
      <mat-form-field appearance="outline" class="login-form-field" [hideRequiredMarker]="true">
        <mat-label>Podaj nick</mat-label>
        <input
          matInput
          id="email"
          class="clean-autofill"
          type="email"
          [formControl]="form.nick"
          name="email"
          required
          autocomplete="nick"
          appGtmFormEvent
          [eventField]="'nick'"
          [eventForm]="'nick'"
        />
        <mat-error *ngIf="form.invalid">
          {{ nickError }}
        </mat-error>
      </mat-form-field>

      <app-new-loader-button
        [disabled]="submitted && (this.form.invalid || !this.form.nick.valid)"
        [appApiCallLoading]="onSubmit"
        [loading]="loading"
        class="big-button button-250"
        id="login-button"
        [customType]="LoaderButtonType.RAISED"
        color="accent">
        Dalej
      </app-new-loader-button>
    </div>
  </form>

</ng-container>
